import styled, { css } from 'styled-components';
import { ArdoqLoaderComponentArgs } from './types';
import { LoaderSize } from './consts';

const DURATION = '3s';
const STROKE_WIDTH = 15;

const sizeToSpeed: Record<LoaderSize, number> = {
  [LoaderSize.SMALL]: 3,
  [LoaderSize.MEDIUM]: 2,
  [LoaderSize.LARGE]: 1,
};

type SpinnerStyleProps = { $color: string; $size: LoaderSize };
const getAnimationCSS = ({ $size }: SpinnerStyleProps) => {
  const speed = sizeToSpeed[$size];
  const keyFrameName = `spinner${speed}`;

  return css`
    animation: ${keyFrameName} ${DURATION} infinite linear;
    @keyframes ${keyFrameName} {
      to {
        transform: rotate(${speed}turn);
      }
    }
  `;
};

const SpinnerStyle = styled.svg<SpinnerStyleProps>`
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  border-radius: 50%;
  background: conic-gradient(#0000, ${props => props.$color});
  mask: radial-gradient(
    closest-side,
    #0000
      calc(100% - ${props => STROKE_WIDTH / (LoaderSize.LARGE / props.$size)}px),
    #000 0
  );
  ${getAnimationCSS}
`;

export const ArdoqLoaderSpinner = ({
  color,
  size,
}: ArdoqLoaderComponentArgs) => (
  <SpinnerStyle
    viewBox={`0 0 ${size} ${size}`}
    xmlns="http://www.w3.org/2000/svg"
    $color={color}
    $size={size}
  />
);
